import _ from 'lodash';
import { dispatchConfirmationTypes, grts, responseHandlers, responseReducers } from '../../../../global/cnr/reducers/reducerHelpers/dispatchProps';
import { getFirstObject } from '../../../../global/common/convert';
import { gEnums } from '../../../../global/enums/globalEnums';
import { createTournamentInfo } from '../../helpers/tournamentData';
import { createSportsHelpers } from './reducerHelpers/createSportsData';
import { seasonalHelpers, seasonalUpdateTypes } from './reducerHelpers/seasonalSportsData';

const rts = {
  handleCreate_levelSections: 'handleCreate_levelSections',
  // handleCreate_playoff: 'handleCreate_playoff',
  handleCreate_pools: 'handleCreate_pools',
  handleCreate_staff: 'handleCreate_staff',
  handleCreate_teamRoster: 'handleCreate_teamRoster',
  // handleCreate_tournament: 'handleCreate_tournament',
  handleDbUpdate_seasonal: 'handleDbUpdate_seasonal',
  handleInit_teamsInfo: 'handleInit_teamsInfo',
  handleSectionSelect: 'handleSectionSelect',
  handleSelect_playoffTeam: 'handleSelect_playoffTeam',
  handleSet_levelQualifyCount: 'handleSet_levelQualifyCount',
  handleSet_next: 'handleSet_next',
  handleSet_nominations: 'handleSet_nominations',
  handleSet_seasonDetails: 'handleSet_seasonDetails',
  handleSet_selectedAthletes: 'handleSet_selectedAthletes',
  handleSet_selectedTeams: 'handleSet_selectedTeams',
  handleSet_sortedLevels: 'handleSet_sortedLevels',
  handleSet_teamRosters: 'handleSet_teamRosters',
  handleShow_importFromGs: 'handleShow_importFromGs',
  handleUpdate_allStarTeams: 'handleUpdate_allStarTeams',
  handleUpdate_playoffInfo: 'handleUpdate_playoffInfo',
  handleUpdate_pools: 'handleUpdate_pools',
  handleUpdate_poolsFromSeeds: 'handleUpdate_poolsFromSeeds',
  handleUpdate_rankings: 'handleUpdate_rankings',
  handleUpdate_seededTeams: 'handleUpdate_seededTeams',
  ...grts,
}

export const sectionCountTypes = {
  checked: 'checked',
  qualifyCount: 'qualifyCount',
  sectionCount: 'sectionCount',
}

export const createScheduleTypes = {
  crossover: 'crossover',
  season: 'season',
  playoff: 'playoff',
}

/** 
 * @param {object} state 
 * @param {object} action 
 * @returns 
 */
export const createSportsReducer = (state, action) => {

  const {
    database_fns,
    grid_info,
    levels_info,
    parentDataKeys,
    pathViews,
    pickedTeams,
    playoff_info,
    pools,
    season_info,
    sportPermissions,
    sportsDetails,
    sportsKey,
    sportsSeason_data,
  } = state

  let {
    schoolTeamInfo,
    teams_info
  } = state

  const _updateProps = seasonalHelpers.getUpdateProps(database_fns, sportPermissions, pathViews, database_fns)

  const _seasonInfo = _.cloneDeep(season_info)
  const _levels_info = _.cloneDeep(levels_info)
  const { existing, next } = _levels_info
  const _existing = { ...existing }
  const _next = { ...next }

  const _playoffInfo = { ...playoff_info }
  const { playoffTeams } = _playoffInfo ?? {}

  const { type, dispatch, levelItem, sectionItem, itemChecked } = action

  const { year: sportsYears } = sportsDetails ?? {}

  const { levels, sections, teams, schools } = sportsSeason_data

  const { gridMatches } = grid_info ?? {}

  const _sportsData = { ...sportsSeason_data }

  const { selected: teams_selected } = teams_info ?? {}
  const tcc = _next ? createSportsHelpers.getTeamCountOptions(_.pickBy(_next, { checked: true })) : []

  const {
    handleStopUpdate,
    handleUpdate_playoffInfo,
    handleUpdate_poolsFromSeeds,
  } = createSportsHandlers(dispatch)

  switch (type) {

    case rts.handleSet_next:
      _levels_info.next = action.next
      const { teams: xxxx } = createSportsHelpers.getTeamsFromLevelSections(_levels_info, state.seasonal_current)
      return { ...state, seasonal_current: { ...state.seasonal_current, teams: xxxx }, levels_info: _levels_info }

    case rts.handleUpdate_seededTeams:
      return { ...state, seededTeams: action.seededTeams }

    case rts.handleInit_teamsInfo:
      const fff = createSportsHelpers.ammend_something(state)
      if (action.teamsFromSchools) {
        return { ...fff, currentInfo: fff.schools_info, teamsFromSchools: action.teamsFromSchools }
      } else {
        return { ...fff, currentInfo: fff.teams_info, teamsFromSchools: action.teamsFromSchools }
      }

    case rts.handleSet_selectedTeams:
      const st = []
      if (teams && action.selected) {
        action.selected.forEach(si => {
          if (teams[si]) {
            st.push(teams[si])
          }
        })
      }
      const _tt = {
        selected: st, //_.sortBy(st, 'name'),
        // selectedIndexes: action.selected
      }
      return { ...state, teams: _tt }

    case rts.handleSelect_playoffTeam:
      if (_.includes(playoffTeams, action.team)) {
        _.remove(playoffTeams, function (n) {
          return n.id === action.team.id;
        });
      } else {
        playoffTeams.push(action.team)
      }
      _playoffInfo.playoffTeams = playoffTeams
      _playoffInfo.playoffLevelTeams = createSportsHelpers.add_playoffLevelTeam(_playoffInfo, state.playoffGroupKey, action.team)
      return { ...state, playoff_info: _playoffInfo }

    case rts.handleSet_levelQualifyCount:

      const { data: data_qualify } = action
      const { value: value_qualify, lskey: lskey_qualify } = data_qualify

      if (_next && _next[lskey_qualify]) {
        _next[lskey_qualify][sectionCountTypes.qualifyCount] = value_qualify
      }
      _levels_info.next = _next

      let _qualifyReady = true

      if (_next) {
        Object.keys(_next).forEach(nk => {
          if (_next[nk].checked && !_next[nk][sectionCountTypes.qualifyCount])
            _qualifyReady = false
        })
      }

      return {
        ...state,
        levels_info: _levels_info,
        qualifyReady: _qualifyReady,
      }

    case rts.handleSectionSelect:
      if (_existing[action.level] && _existing[action.level].sections) {
        const _sections = _existing[action.level].sections
        const sectionKeys = action.value
        Object.keys(_sections).forEach(sk => {
          if (sectionKeys.includes(sk)) {
            _existing[action.level].sections[sk].checked = true
          } else {
            _existing[action.level].sections[sk].checked = false
          }
        })
      }
      return { ...state, levels_info: _levels_info }

    // ****** POOLS *********

    case rts.handleCreate_pools:
      const _pools = {}
      for (var i = 1; i <= action.poolCount; i++) { _pools['pool' + i] = [] }
      return { ...state, pools: _pools }

    case rts.handleUpdate_pools:
      const { groupkey: poolKey, value: poolTeamKey } = action.selectedItem
      if (teams_selected) {
        const selectedTeam = _.find(teams_selected, { id: poolTeamKey })
        if (selectedTeam) {
          if (pools && pools[poolKey]) {
            pools[poolKey].push(selectedTeam)
            const picked = pickedTeams ? [...pickedTeams] : []
            if (!picked.includes(poolTeamKey)) { picked.push(poolTeamKey) }
            return { ...state, pools, pickedTeams: picked, ready_alignment: true }
          }
        }
      }

      return state

    case rts.handleUpdate_poolsFromSeeds:
      const { tournament } = action
      const { rounds } = tournament
      const round1 = rounds.round1
      const { pools: pools_round } = round1 ?? {}
      if (pools_round) {
        Object.keys(pools_round).forEach(poolKey => {
          const pool = pools_round[poolKey]
          if (pools && pools[poolKey] && pool.teams) {
            Object.keys(pool.teams).forEach(teamKey => {
              const poolTeam = pool.teams[teamKey]
              pools[poolKey].push(poolTeam)
            })
          }
        })
      }
      return { ...state, pools, tournament }

    case rts.handleSet_seasonDetails:
      return { ...state, seasonal_current: { ...state.seasonal_current, details: action.sportsDetails } }


    case rts.handleUpdate_playoffInfo:
      _playoffInfo.tournaments = action.tournaments
      _playoffInfo.matches = action.playoffMatches
      return { ...state, playoff_info: _playoffInfo }

    // case rts.handleCreate_playoff:
    //   createTournamentInfo(true, state, handleUpdate_playoffInfo)
    //   return state

    // case rts.handleCreate_tournament:
    //   // teams_selected - array
    //   // seededTeams - object
    //   createTournamentInfo(false, state, handleUpdate_poolsFromSeeds)
    //   return state

    case rts.handleSet_teamRosters:
      if (action.rosters) {
        const _teamRosters = createSportsHelpers.addTeamInfoToTeamRosters(action.rosters, teams)
        const rosters = { teams: _.groupBy(_teamRosters, 'teams'), levels: _.groupBy(_teamRosters, 'levels'), sport: _teamRosters }
        return { ...state, rosters: rosters }
      }
      return state

    case rts.handleSet_nominations:
      const { nominations } = action
      const { item: _first } = getFirstObject(nominations)
      const { athletes } = _first ?? {}
      let _nominations = {}
      if (athletes) {
        Object.keys(athletes).forEach(teamKey => {
          const team = athletes[teamKey]
          const { item: _level } = getFirstObject(team)
          if (_level) {
            _nominations = { ..._nominations, ..._level }
          }
        })
      }
      const _noms = _.groupBy(_nominations, 'levels')
      return { ...state, nominations: _noms }

    case rts.handleSet_selectedAthletes:
      let _selectedAthletes = { ...state.selectedAthletes }
      if (!_selectedAthletes) { _selectedAthletes = {} }
      if (!_selectedAthletes) { _selectedAthletes[levelItem] = _selectedAthletes[levelItem] = {} }
      _selectedAthletes[levelItem] = action.selectedAthletes
      let total = 0
      if (_selectedAthletes) {
        Object.keys(_selectedAthletes).forEach(k => {
          if (_selectedAthletes[k]) {
            total += Object.keys(_selectedAthletes[k]).length
          }
        })
      }
      return { ...state, selectedAthletes: _selectedAthletes, totalAthletes: total }

    case rts.handleSet_sortedLevels:
      return {
        ...state,
        createRankings_info: {
          sortedLevels: action.sortedLevels,
          selectedLevel: action.selectedLevel,
          selectedWeek: action.selectedWeek
        }
      }

    // ****** LEVELS AND SECTIONS *********

    case rts.handleCreate_levelSections:
      const { levels_info: _lst, teamCounts: _tc } = createSportsHelpers.createLevelsAndSections(levels, sections, _levels_info)
      return { ...state, levels_info: _lst, teamCounts: _tc }

    // ****** UPDATES *********

    case rts.handleCreate_teamRoster:

      const { newAthletes, newRosters, rosterType } = action
      const cb7 = () => { console.log('Added') }
      switch (rosterType) {
        case 'athletes':
          const pks_athletes = seasonalHelpers.getPks(pathViews, action.latestSeason, sportsKey)
          seasonalHelpers.ammend_updateProps(_updateProps, pks_athletes, cb7)
          seasonalHelpers.ammend_updateNameProps(_updateProps, 'athletes', null, newAthletes)
          seasonalHelpers.updateSportsCollectionItemsWithParentKeys(database_fns, seasonalUpdateTypes.athletes, _updateProps, 'athletes', newAthletes)
          break;
        case 'roster':
          const pks_roster = seasonalHelpers.getPks(pathViews, action.latestSeason, sportsKey)
          seasonalHelpers.ammend_updateProps(_updateProps, pks_roster, cb7)
          seasonalHelpers.ammend_updateNameProps(_updateProps, 'rosters', 'athletes', newRosters)
          seasonalHelpers.update_seasonalOrGlobal(seasonalUpdateTypes.rosters, _updateProps)
          break;
        default:
        // nothing
      }

      return state

    case rts.handleCreate_staff:
      const cb8 = () => { console.log('Added') }
      const pks_staff = seasonalHelpers.getPks(pathViews, sportsYears, sportsKey)
      seasonalHelpers.ammend_updateProps(_updateProps, pks_staff, cb8)
      seasonalHelpers.ammend_updateNameProps(_updateProps, 'staff', 'staff', action.staff, { ignoreSeason: true, updateToMain: true })
      seasonalHelpers.update_seasonalOrGlobal(seasonalUpdateTypes.staff, _updateProps)
      return state

    case rts.handleUpdate_allStarTeams:
      // LOOK
      // seasonalHelpers.updateSeasonalOrGlobal(seasonalUpdateTypes.allStarTeams, _updateProps, 'athletes', action.data, action.collectionName, true)
      return state

    case rts.handleUpdate_rankings:
      const data_rankings = createSportsHelpers.getRankingData(action)
      const _pkss = seasonalHelpers.getPks(pathViews, state.latestSeason, sportsKey)
      seasonalHelpers.ammend_updateProps(_updateProps, _pkss, action.callback)
      seasonalHelpers.ammend_updateNameProps(_updateProps, 'rankings', null, data_rankings)
      seasonalHelpers.update_seasonalOrGlobal(seasonalUpdateTypes.rankings, _updateProps)
      return state

    case rts.handleDbUpdate_seasonal:
      const cbx = (result) => { console.log('Updated', result) }
      let seasonalUpdateType;
      let docFieldName;
      switch (action.seasonalType) {
        case gEnums.availableSubActionTypes.editSeasonDetails:
          docFieldName = seasonalUpdateTypes.details
          seasonalUpdateType = seasonalUpdateTypes.details
          break;
        case gEnums.availableSubActionTypes.sportsSettings:
          docFieldName = seasonalUpdateTypes.sportsSettings
          seasonalUpdateType = seasonalUpdateTypes.sportsSettings
          break;
        default:
        // nothing
      }
      if (docFieldName) {
        const _pkssx = seasonalHelpers.getPks(pathViews, state.latestSeason, sportsKey)
        // _seasonals(parentKeys)/teams/details
        seasonalHelpers.ammend_updateProps(_updateProps, _pkssx, cbx)
        seasonalHelpers.ammend_updateNameProps(_updateProps, null, docFieldName, action.seasonalData)
        seasonalHelpers.update_seasonalOrGlobal(seasonalUpdateType, _updateProps)
      }

      return state

    case rts.handleShow_importFromGs:
      return { ...state, showImportFromGs: !state.showImportFromGs }

    case rts.handleCloseConfirmation:
    case rts.handleFunctionResponse:
    case rts.handleStartUpdate:
    case rts.handleStopUpdate:
      return responseReducers(state, action, { dispatch, dispatchConfirmationType: dispatchConfirmationTypes.closeAfterUpdate }, { gsMatchedRefreshed: false })

    default:
      return state
  }
}

export const createSportsHandlers = (dispatch) => {
  return {
    handleAmmend_schoolTeamInfo_all: (schoolKey, schoolName, checked) => { dispatch({ type: rts.handleAmmend_schoolTeamInfo_all, dispatch, schoolKey, schoolName, checked }) },
    handleCreate_levelSections: () => { dispatch({ type: rts.handleCreate_levelSections, dispatch }) },
    // handleCreate_playoff: () => { dispatch({ type: rts.handleCreate_playoff, dispatch }) },
    handleCreate_pools: (poolCount) => { dispatch({ type: rts.handleCreate_pools, dispatch, poolCount }) },
    handleCreate_staff: (staff) => { dispatch({ type: rts.handleCreate_staff, dispatch, staff }) },
    handleCreate_teamRoster: (latestSeason, newAthletes, newRosters, rosterType) => { dispatch({ type: rts.handleCreate_teamRoster, dispatch, latestSeason, newAthletes, newRosters, rosterType }) },
    // handleCreate_tournament: () => { dispatch({ type: rts.handleCreate_tournament, dispatch }) },
    handleDbUpdate_seasonal: (seasonalType, seasonalData, latestSeason, callback) => { dispatch({ type: rts.handleDbUpdate_seasonal, dispatch, seasonalType, seasonalData, latestSeason, callback }) },
    handleInit_teamsInfo: (teamsFromSchools) => { dispatch({ type: rts.handleInit_teamsInfo, dispatch, teamsFromSchools }) },
    handleSectionSelect: (level, value) => { dispatch({ type: rts.handleSectionSelect, dispatch, level, value }) },
    handleSelect_playoffTeam: (team) => { dispatch({ type: rts.handleSelect_playoffTeam, dispatch, team }) },
    handleSet_levelQualifyCount: (data) => { dispatch({ type: rts.handleSet_levelQualifyCount, dispatch, data }) },
    handleSet_next: (next) => { dispatch({ type: rts.handleSet_next, dispatch, next }) },
    handleSet_nominations: (nominations) => { dispatch({ type: rts.handleSet_nominations, dispatch, nominations }) },
    handleSet_seasonDetails: (sportsDetails) => { dispatch({ type: rts.handleSet_seasonDetails, dispatch, sportsDetails }) },
    handleSet_selectedAthletes: (level, selectedAthletes) => { dispatch({ type: rts.handleSet_selectedAthletes, dispatch, level, selectedAthletes }) },
    handleSet_selectedTeams: (selected) => { dispatch({ type: rts.handleSet_selectedTeams, dispatch, selected }) },
    handleSet_sortedLevels: (sortedLevels, selectedLevel, selectedWeek) => { dispatch({ type: rts.handleSet_sortedLevels, dispatch, sortedLevels, selectedLevel, selectedWeek }) },
    handleSet_teamRosters: (rosters) => { dispatch({ type: rts.handleSet_teamRosters, dispatch, rosters }) },
    handleShow_importFromGs: () => { dispatch({ type: rts.handleShow_importFromGs, dispatch }) },
    handleUpdate_allStarTeams: (data, collectionName) => { dispatch({ type: rts.handleUpdate_allStarTeams, dispatch, data, collectionName }) },
    handleUpdate_playoffInfo: (tournaments, playoffMatches) => { dispatch({ type: rts.handleUpdate_playoffInfo, dispatch, tournaments, playoffMatches }) },
    handleUpdate_pools: (selectedItem) => { dispatch({ type: rts.handleUpdate_pools, dispatch, selectedItem }) },
    handleUpdate_poolsFromSeeds: (tournament) => { dispatch({ type: rts.handleUpdate_poolsFromSeeds, dispatch, tournament }) },
    handleUpdate_rankings: (actionProps, handleDone) => { dispatch({ type: rts.handleUpdate_rankings, dispatch, actionProps, handleDone }) },
    handleUpdate_seededTeams: (seededTeams) => { dispatch({ type: rts.handleUpdate_seededTeams, dispatch, seededTeams }) },
    ...responseHandlers(dispatch),
  }
}

export const createSportsInitialState = (init_state) => {

  const { teams_info, teams, pathViews, teams_fromMatches, parentDataKeys } = init_state
  const { sports } = pathViews

  const _playoffTeams = getPlayoffTeamsInit(teams)
  const _playoffLevelTeams = getPlayoffLevelTeamsInit(teams)

  const pdts = ammendPlayoffDatesNeeded(_playoffLevelTeams)

  return {
    ...init_state,
    currentSport: sports,
    seasonal_current: {},
    sportsDetails: {},
    levels_info: {
      existing: {},
      next: {},
      ready: false,
    },
    schools_info: {
      existing: {},
      nonSelected: {},
      selected: {},
    },
    teams_info: teams_info || {
      counts: [],
      created: [],
      fromMatches: teams_fromMatches,
      nonSelected: {},
      playoff: {},
      selected: {},
    },
    sportsSeason_data: {
      levels: {},
      sections: {},
      schools: {},
      teams: {}
    },
    playoff_info: {
      playoffTeams: _playoffTeams,
      playoffLevelTeams: _playoffLevelTeams,
      ...pdts
    },
    rosters: {},
    selectedAthletes: {},
    nominations: {},
    mediaSeason: {},
    parentDataKeys
  };
}

const ammendPlayoffDatesNeeded = (playoffLevelTeams) => {

  const playoffDates = {}
  const playoffDates_ready = {}
  const playoffDates_needed = {}

  if (playoffLevelTeams) {
    Object.keys(playoffLevelTeams).forEach(key => {
      const lt = playoffLevelTeams[key]
      playoffDates[key] = []
      playoffDates_ready[key] = false
      playoffDates_needed[key] = datesNeeded(lt.length)
    })
  }

  return { playoffDates, playoffDates_ready, playoffDates_needed }

}

const ammend_teamInfo = (state, teams, counts, teamData, playoffTeams, teams_grid, _school_data) => {

  const { teams_info, pathViews, sportsKey, sportsDetails } = state ?? {}
  const { defaultFromLastSeason } = sportsDetails ?? {}
  const _teams_info = { ...teams_info, ...teamData }

  if (counts) { _teams_info.counts = counts }
  if (playoffTeams) { _teams_info.playoff = playoffTeams }
  if (teams_grid) { _teams_info.selected = teams_grid }

  if (defaultFromLastSeason && _teams_info) {

  }

  if (_teams_info.fromMatches) {

    const _parentKeys = {
      districts: pathViews.districts,
      organizations: pathViews.organizations,
      sports: sportsKey,
    }

    const _existing = {}

    Object.keys(_teams_info.fromMatches).forEach(k => {
      const t = _teams_info.fromMatches[k]
      _existing[k] = {
        name: t.name,
        parentKeys: _parentKeys,
        id: k,
        _itemKey: k,
      }
    })

    if (_school_data) {
      updateTeamSchoolParentKeys(_teams_info.existing, _school_data.existing)
    }
  }

  return _teams_info

}

const updateTeamSchoolParentKeys = (teams_existing, schools_existing) => {

  Object.keys(teams_existing).forEach(tk => {
    const _team_existing = _.cloneDeep(teams_existing[tk]);
    const { parentKeys } = _team_existing ?? {}
    const { schools: key_school } = parentKeys ?? {}
    if (!key_school) {
      const _schoolKey = _.findKey(schools_existing, { name: _team_existing.name })
      if (_schoolKey) {
        _team_existing.parentKeys.schools = _schoolKey
        _team_existing._isNew = true
      }
    }
    teams_existing[tk] = _team_existing
  })

}

const datesNeeded = (teamCount) => {
  switch (true) {
    case teamCount > 16 && teamCount <= 32:
      return 5
    case teamCount > 8 && teamCount <= 16:
      return 4
    case teamCount > 4 && teamCount <= 8:
      return 3
    case teamCount > 3 && teamCount <= 4:
      return 2
    default:
    // nothing
  }
}

/**
 * 
 * @param {object} teams 
 * @returns a list of teams whose record indicates that they are a playoffTeam
 */
const getPlayoffTeamsInit = (teams) => {
  const _teams = _.filter(teams, (t) => t.record && t.record.playoffTeam)
  return _teams
}

/**
 * 
 * @param {*} teams 
 * @returns a list of teams whose record indicates that they are a playoffTeam, grouped by the `levels` of the teams
 */
const getPlayoffLevelTeamsInit = (teams) => {
  const _teams = _.filter(teams, (t) => t.record && t.record.playoffTeam)
  const teams_levels = _teams ? _.groupBy(_teams, 'levels') : null
  return teams_levels
}

export const ammendSchoolName = (teamName) => {

  let tn = teamName

  switch (tn) {
    case 'Aquinas Academy of Pittsburgh':
      tn = 'Aquinas Academy'
      break;

    case 'Bethlehem-Center':
    case 'Bethlehem Center':
      tn = 'Beth Center'
      break;

    case 'Canon McMillan':
    case 'Canon-McMillian':
      tn = 'Canon McMillan'
      break;

    case 'Ellwood City Lincoln':
      tn = 'Ellwood City'
      break;

    case 'The Ellis School':
      tn = 'Ellis School'
      break;

    case 'Hillel Academy  of Pittsburgh':
      tn = 'Hillel Academy'
      break;

    case 'Lincoln Park Performing Arts Charter School':
      tn = 'Lincoln Park'
      break;

    case 'OLSH':
    case 'Our Lady of the Sacred Heart':
      tn = 'O.L.S.H.'
      break;

    case 'Seton LaSalle Catholic':
      tn = 'Seton LaSalle'
      break;

    case 'Sto Rox':
      tn = 'Sto-Rox'
      break;

    case 'Trinity Christian School':
      tn = 'Trinity Christian'
      break;

    case 'The Neighborhood Academy':
      tn = 'Neighborhood Academy'
      break;

    case 'Waynesburg Central':
      tn = 'Waynesburg'
      break;

    case 'Eden Christian Acad.':
      tn = 'Eden Christian'
      break;

    case 'Hillcrest Christ. Acad.':
      tn = 'Hillcrest Christian'
      break;

    // case 'Serra Catholic':
    //   tn = 'Serra'
    //   break;

    case 'Geibel Catholic':
      tn = 'Geibel'
      break;

    case 'South Side':
    case 'South Side Beaver':
      tn = 'South Side Area'
      break;

    default:
    // nothing 
  }

  return tn

}

export const findSchool = (teamName, schools_existing) => {

  let tn = ammendSchoolName(teamName)

  let school = _.find(schools_existing, { name: tn })

  if (!school) {
    tn = tn.replace('-', ' ')
    school = _.find(schools_existing, { name: tn })
  }

  if (!school) {
    if (tn.indexOf('Co.') >= 0) {
      tn = tn.replace('Co.', 'County')
      school = _.find(schools_existing, { name: tn })
    }
  }

  if (!school) {
    if (tn.indexOf('C.C.') >= 0) {
      tn = tn.replace('C.C.', 'Central Catholic')
      school = _.find(schools_existing, { name: tn })
    }
  }

  if (!school) {
    if (tn.indexOf('Ft.') >= 0) {
      tn = tn.replace('Ft.', 'Fort')
      school = _.find(schools_existing, { name: tn })
    }
  }

  if (!school) {
    if (tn.indexOf('Saint') >= 0) {
      tn = tn.replace('Saint', 'St.')
      school = _.find(schools_existing, { name: tn })
    }
  }

  if (!school) {
    if (tn.indexOf('Area') >= 0) {
      tn = tn.replace(' Area', '')
      school = _.find(schools_existing, { name: tn })
    }
  }

  if (!school) {
    if (tn.indexOf('Greater') >= 0) {
      tn = tn.replace('Greater ', '')
      school = _.find(schools_existing, { name: tn })
    }
  }

  if (!school) {
    if (tn.indexOf('Neighborhood Acad ©') >= 0) {
      tn = tn.replace('Neighborhood Acad ©', 'Neighborhood Academy')
      school = _.find(schools_existing, { name: tn })
    }
  }

  if (!school) {
    tn += ' Area'
    school = _.find(schools_existing, { name: tn })
  }

  if (!school) {
    console.log('school', school)
  }

  return { school, tn }

}

function isValidDate(dateString) {

  // Regular expression to match YYYY-MM-DD format
  // const regex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;
  const regex = /^(0?[1-9]|1[0-2])\/(0?[1-9]|[12][0-9]|3[01])\/\d{4}$/;

  if (!regex.test(dateString)) {
    return false; // Invalid format
  }

  const parts = dateString.split("/");
  const month = parseInt(parts[0]);
  const day = parseInt(parts[1]);
  const year = parseInt(parts[2]);

  const date = new Date(year, month - 1, day);

  return (
    date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day
  );
}
